export const APPLICATION_TYPE_COLLECTION_AGENCY = "collection-agency";
export const APPLICATION_TYPE_COLLECTOR = "collection-agency-collector";
export const APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY = "debt-management-agency";
export const APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT = "debt-management-agent";
export const APPLICATION_TYPE_BUSINESS_LICENCE_ADMIN = "business-licence-admin";
export const APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE =
  "mortgage-brokerage-licence";
export const APPLICATION_TYPE_MORTGAGE_PRINCIPAL_BROKER_LICENCE =
  "mortgage-principal-broker-licence";
export const APPLICATION_TYPE_MORTGAGE_INDIVIDUAL_BROKER_LICENCE =
  "mortgage-broker-licence";
export const APPLICATION_TYPE_MORTGAGE_ASSOCIATE_BROKER_LICENCE =
  "mortgage-associate-broker-licence";
export const APPLICATION_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_LICENCE = "individual-principal-broker-licence";
export const APPLICATION_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_LICENCE = "individual-compliance-officer-licence";

export const APPLICATION_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_LICENCE = "individual-principal-broker-retention-licence";
export const APPLICATION_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_RETENTION_LICENCE = "individual-compliance-officer-retention-licence";

// May need to change later - application type mortgage lender
export const APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE = "mortgage-lender-licence";
export const APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE = "mortgage-administrator-licence";

// a page to list basic details of mortgage companies
export const APPLICATION_TYPE_MORTGAGE_DETAILS = "mra-details";